
<div class="modal-header">
  <h4 class="modal-title">Observation</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close();"></button>
</div>
<form #obsForm="ngForm" (ngSubmit)="submit(obsForm)">
<div class="modal-body">
  <div class="row mb-2">
    <label for="date" class="required-field col-md-4">Date</label>
    <div class="col-md-8">
      <input #date="ngModel" [(ngModel)]="observation.date" class="form-control" type="date" name="date" id="date" required [disabled]="!edit">
      <div class="text-danger" *ngIf="obsForm.touched && date.errors?.required">
        A date is required.
      </div>
    </div>
  </div>
  <div class="row mb-2">
    <label for="observers" class="col-md-4 required-field">Observers</label>
    <div class="col-md-8">
      <staff-list (staffChange)="onStaffChange(obsForm, $event)" [edit]="edit" [form]="obsForm" [addOnSelect]="true"
                  [staff]="observation.observer_ids"></staff-list>
      <div class="text-danger" *ngIf="edit && obsForm.touched && observation.observer_ids?.length === 0">
        At least one observer is required.
      </div>
    </div>
  </div>
  <div class="row mb-2">
    <label for="observer_str" class="col-md-4">Other Observers</label>
    <div class="col-md-8">
      <textarea [(ngModel)]="observation.observer_str" class="form-control" name="observer_str" id="observer_str"
                [disabled]="!edit"></textarea>
    </div>
  </div>
  <div class="row mb-2">
    <label for="academic_area" class="required-field col-md-4">Academic Area</label>
    <div class="col-md-8">
      <select [(ngModel)]="observation.academic_area" class="form-select" name="academic_area" id="academic_area" required [disabled]="!edit">
        <option *ngFor="let a of academic_areas" [value]="a.name">{{ a.name }}</option>
      </select>
      <div class="text-danger" *ngIf="obsForm.touched && obsForm.form.controls.academic_area.errors?.required">
        An academic area is required.
      </div>
    </div>
  </div>
  <div class="row mb-2">
    <label for="activities" class="col-md-4">Instructional Activities</label>
    <div class="col-md-8">
      <textarea [(ngModel)]="observation.activities" class="form-control" name="activities" id="activities"
                [disabled]="!edit"></textarea>
    </div>
  </div>
  <div class="row mb-2">
    <label for="materials" class="col-md-4">Instructional Materials</label>
    <div class="col-md-8">
      <textarea [(ngModel)]="observation.materials" class="form-control" name="materials" id="materials"
                [disabled]="!edit"></textarea>
    </div>
  </div>
  <div class="row mb-2">
    <label for="presentation" class="col-md-4">Manner of Presentation</label>
    <div class="col-md-8">
      <textarea [(ngModel)]="observation.presentation" class="form-control" name="presentation" id="presentation"
                [disabled]="!edit"></textarea>
    </div>
  </div>
  <div class="row mb-2">
    <label for="observations" class="col-md-4">Observations</label>
    <div class="col-md-8">
      <textarea [(ngModel)]="observation.observation" class="form-control" name="observations" id="observations"
                [disabled]="!edit"></textarea>
    </div>
  </div>
  <div class="row mb-2">
    <label for="comparison" class="col-md-4">Peer Comparison</label>
    <div class="col-md-8">
      <textarea [(ngModel)]="observation.peer_comparison" class="form-control" name="comparison" id="comparison"
                [disabled]="!edit"></textarea>
    </div>
  </div>
</div>
<div class="modal-footer">
  <ng-container *ngIf="!edit">
    <button type="button" class="btn btn-warning me-3" aria-label="Edit Observation" (click)="editObservation()">
      <span class="bi bi-pencil me-2"></span> Edit
    </button>
    <button type="button" class="btn btn-outline-info" aria-label="Close" (click)="close()">
      <span class="bi bi-x me-2"></span> Close
    </button>
  </ng-container>
  <ng-container *ngIf="edit">
    <button type="button" class="btn btn-primary me-2" aria-label="Save" (click)="submit(obsForm)" [disabled]="obsForm.pristine || obsForm.errors">
      <span class="bi bi-floppy me-2"></span> Save
    </button>
    <button type="button" class="btn btn-warning" aria-label="Cancel" (click)="cancel()">
      <span class="bi bi-ban me-2"></span> Cancel
    </button>
  </ng-container>
</div>
</form>
